import { render, staticRenderFns } from "./vue-element.vue?vue&type=template&id=627121c8&lang=html&"
import script from "./vue-element.vue?vue&type=script&lang=js&"
export * from "./vue-element.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports